// hook dependancies
import { useGlobal, setGlobal } from "reactn";

// helpers
import { capitaliseFirstLetters } from "../helpers/Helpers";
import { getPhoneNumberValues } from "../components/_common/mobileGroup/Mobile.helpers";

/**
 *
 */
const useProfileHooks = () => {
    const [profile] = useGlobal("profile");
    const [values] = useGlobal("values");
    const [moneyUser] = useGlobal("moneyUser");
    const [activeSideLink] = useGlobal("activeSideLink");
    const [activeTab] = useGlobal("activeTab");
    const [addressObj] = useGlobal("addressObj");

    const setGlobalValue = (id, value) => {
        setGlobal({
            values: { ...values, [id]: value }
        });
    };

    const refreshGlobalVals = updatedVals => {
        setGlobal({
            values: updatedVals
        });
    };

    const setProfileData = profileData => {
        setGlobal({
            values: { ...values, profile: profileData }
        });
    };

    const setActiveSideLink = link => {
        setGlobal({
            activeSideLink: link
        });
    };

    const setActiveTab = name => {
        setGlobal({
            activeTab: name
        });
    };

    const handleMultipleAddress = addresses => {
        setGlobal({
            addressObj: addresses
        });
    };

    const getMobileNumber = phones => {
        let mobileNumber = "";
        for (let i = 0; i < phones.length; i += 1) {
            if (phones[i].type.toUpperCase() === "MOBILE") {
                mobileNumber = phones[i].number;
            }
        }
        return getPhoneNumberValues(mobileNumber);
    };

    const setConsentValues = consents => {
        setGlobal({
            values: { ...values, consents }
        });
    };

    // flag that is returned from getProfile endpoint saying that it is a FS Eco System user (Money user)
    const setMoneyUser = moneyUserFlag => {
        setGlobal({
            moneyUser: moneyUserFlag
        });
    };

    const setProfileValues = (profileData, homeAddressCountry, businessAddressCountry) => {
        const profileTemp = profileData.profile;
        const mobileNumber = getMobileNumber(profileData.phones);
        const updatedVals = {
            ...values,
            profileFirstName: profileTemp.firstName,
            profileLastName: profileTemp.lastName,
            profileEmailAddress: profileData.email,
            profileMobile: mobileNumber.fullNumber,
            profileMobileCountryCode: mobileNumber.countryCode.replace(/\s/g, ""),
            profileMobilePrefix: mobileNumber.prefix.replace(/\s/g, ""),
            profileMobileNumber: mobileNumber.subNumber.replace(/\s/g, ""),
            profileOldMobileNumber: mobileNumber.fullNumber,
            createNewMobileNumber: !mobileNumber.fullNumber,
            createNewAddress: !homeAddressCountry,
            profileAddress: homeAddressCountry === "Ireland" ? "addressSet" : "",
            profileAddressNatOrInternational: homeAddressCountry === "Ireland" ? "national" : "international",
            createNewBusinessAddress: !businessAddressCountry,
            businessAddress: businessAddressCountry === "Ireland" ? "addressSet" : "",
            noAddresses: profileData.addresses.length === 0,
            profileCompanyName: profileTemp.business.name,
            profileCompanyRegNumber: profileTemp.business.companyRegNumber,
            profileVatNumber: profileTemp.business.vatNumber,
            profileIndustry: profileTemp.business.industry
        };
        setGlobal({
            values: updatedVals
        });

        setMoneyUser(profileData.ecoSystemCustomer === "true");

        return updatedVals;
    };

    const getDefaultAddress = (addresses, type) => {
        for (let i = 0; i < addresses.length; i += 1) {
            if (addresses[i].displayName === type) {
                return addresses[i];
            }
        }
        return null;
    };

    // Format address for display on the Profile Info Page
    const formatAddress = address => {
        if (!address) return null;

        return `${address.organisationName ? capitaliseFirstLetters(address.organisationName) : ""} 
        ${address.addressLine1 ? capitaliseFirstLetters(address.addressLine1) : ""} 
        ${address.addressLine2 ? capitaliseFirstLetters(address.addressLine2) : ""} 
        ${address.addressLine3 ? capitaliseFirstLetters(address.addressLine3) : ""} 
        ${address.addressLine4 ? capitaliseFirstLetters(address.addressLine4) : ""} 
        ${address.city ? capitaliseFirstLetters(address.city) : ""} 
        ${address.town ? capitaliseFirstLetters(address.town) : ""}
        ${address.county ? capitaliseFirstLetters(address.county) : ""}
        ${address.country ? capitaliseFirstLetters(address.country) : ""}
        ${address.eircode && address.country && address.country.toUpperCase() === "IRELAND" ? address.eircode.toUpperCase() : ""} 
        ${address.postcode && address.country && address.country.toUpperCase() !== "IRELAND" ? address.postcode.toUpperCase() : ""}`;
    };

    return {
        setGlobalValue,
        refreshGlobalVals,
        setProfileData,
        getMobileNumber,
        getDefaultAddress,
        formatAddress,
        setConsentValues,
        setProfileValues,
        handleMultipleAddress,
        setActiveSideLink,
        activeSideLink,
        setActiveTab,
        activeTab,
        addressObj,
        profile,
        values,
        moneyUser,
        setMoneyUser
    };
};

export default useProfileHooks;
